import React from 'react';
import { Rect } from 'react-konva';
import {IRect} from "konva/types/types";
import {percent} from "../../utils";

interface Props extends IRect {
  corner: number,
}

function SlotBorder({ x, y, width, height, corner }: Props) {
  const stroke = percent(2, width);

  return (
    <Rect
      perfectDrawEnabled={false}
      hitStrokeWidth={0}
      shadowForStrokeEnabled={false}
      listening={false}
      width={width - stroke}
      height={height - stroke}
      cornerRadius={corner}
      stroke={'#004D40'}
      strokeWidth={stroke}
      x={x + (stroke / 2)}
      y={y + (stroke / 2)}
    />
  );
}

export default SlotBorder;
